@if (!testMessage) {
  <div class="wz-grid">
    <div class="wz-main">
      <app-message-form></app-message-form>
    </div>

    <aside class="wz-aside" aria-label="Message preview">
      <app-messages-preview (showTestMessage)="showTestMessage($event)"></app-messages-preview>
      <app-campaign-messages (openPopupEvent)="openPopup($event)"></app-campaign-messages>
    </aside>
  </div>

  @if (openEditPopup) {
    <app-edit-message-form
      (closePopupEvent)="closePopup($event)"
      [open]="openEditPopup"
      [msgNo]="editMessageNo"
      (showTestMessage)="showTestMessage($event)"
    ></app-edit-message-form>
  }
} @else {
  <app-test-message (closeTestMessage)="closeTestMessage()" [fromEdit]="fromEdit"></app-test-message>
}
